import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { AnimatedNumber } from "@/components/polish/AnimatedNumber";
import { staggerItem } from "@/lib/motion";

const iconMap = {
  "trending-up": Icons.TrendingUp, factory: Icons.Factory, gauge: Icons.Gauge,
  "alert-triangle": Icons.AlertTriangle, users: Icons.Users, mail: Icons.Mail,
  activity: Icons.Activity, "alert-circle": Icons.AlertCircle, package: Icons.Package,
  target: Icons.Target, "user-check": Icons.UserCheck, "map-pin": Icons.MapPin,
  "indian-rupee": Icons.IndianRupee, "file-text": Icons.FileText, receipt: Icons.Receipt,
  percent: Icons.Percent,
};

export function KpiCard({ kpi, index }) {
  const Icon = iconMap[kpi.icon] || Icons.Sparkles;
  const raw = kpi.value;
  const safe = raw == null || raw === "" ? 0 : raw;
  const numeric = Number(safe);
  const isNumeric = Number.isFinite(numeric);
  const prefix = kpi.unit === "INR" ? "₹ " : "";
  const suffix = kpi.unit === "%" ? "%" : "";

  return (
    <motion.div
      data-testid={`kpi-card-${kpi.key}`}
      variants={staggerItem}
      whileHover={{ y: -4 }}
      transition={{ type: "spring", stiffness: 300, damping: 22 }}
      className="glass card-lift kpi-sheen p-5 relative overflow-hidden"
      style={{ "--sheen-delay": `${(index || 0) * 0.85}s` }}
    >
      <div className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-gradient-primary opacity-10 blur-xl" />
      <div className="flex items-start justify-between mb-3">
        <div className="text-[11px] uppercase tracking-widest text-muted-foreground font-medium">
          {kpi.label}
        </div>
        <div className="h-9 w-9 rounded-xl bg-gradient-primary flex items-center justify-center shadow-md">
          <Icon className="h-4 w-4 text-white" />
        </div>
      </div>
      <div
        className="font-body text-3xl font-bold tracking-tight text-foreground tabular-nums"
        data-testid={`kpi-value-${kpi.key}`}
      >
        {isNumeric ? (
          <AnimatedNumber value={numeric} prefix={prefix} suffix={suffix} />
        ) : (
          String(safe)
        )}
      </div>
      <div className="mt-1 text-[11px] text-muted-foreground">
        {kpi.trend != null && (
          <>
            <span className={kpi.trend >= 0 ? "text-emerald-400" : "text-rose-400"}>
              {kpi.trend >= 0 ? "▲" : "▼"} {Math.abs(kpi.trend)}%
            </span>{" "}
            vs last period
          </>
        )}
      </div>
    </motion.div>
  );
}

export default KpiCard;
